import { AmplitudeConfig } from '../context';

const APP_STAGE = import.meta.env.VITE_APP_STAGE || 'dev';

// for testing purposes on the dev environment : change these conditions
export const AMPLITUDE_API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;
export const AMPLITUDE_CONFIG: Partial<AmplitudeConfig> = {
  autocapture:
    APP_STAGE === 'prod' ? { pageViews: true } : { pageViews: false },
};
